import { normalizeContainerDocument } from '@mts/shared/containerLayout';
import { inspectContentEditorDocument } from '@mts/shared/contentEditorProfiles';

/** Validate before migrating known layout contracts; never manufacture an empty recovery doc. */
export function prepareContentEditorDocument(value, profile) {
  const result = inspectContentEditorDocument(value, profile);
  if (!result.valid) return result;
  const source = JSON.parse(JSON.stringify(result.document));
  const hasLegacyLayout = (node) => ['layoutRow', 'layoutColumn'].includes(node.type) || (node.content || []).some(hasLegacyLayout);
  const document = profile.output.strategy === 'website' && hasLegacyLayout(source) ? normalizeContainerDocument(source) : source;
  if (profile.output.strategy === 'website' && document.content.some((node) => node.type === 'column')) {
    const content = [];
    for (const node of document.content) {
      if (node.type !== 'column') { content.push(node); continue; }
      const previous = content.at(-1);
      if (previous?.type === 'container' && (previous.content || []).every((child) => child.type === 'column')) previous.content = [...(previous.content || []), node];
      else content.push({ type: 'container', attrs: { layout: 'row', wrap: true, stackOnMobile: true }, content: [node] });
    }
    document.content = content;
  }
  return { ...result, document };
}

export function isContentEditorDocumentEmpty(value) {
  const document = value?.schemaVersion ? value.doc : value;
  if (document == null) return true;
  const containers = new Set(['doc', 'paragraph', 'heading', 'blockquote', 'bulletList', 'orderedList', 'listItem', 'layoutRow', 'layoutColumn', 'column', 'container']);
  const hasContent = (node, depth = 0) => {
    if (depth > 100 || !node || typeof node !== 'object') return false;
    if (node.type === 'text') return Boolean(typeof node.text === 'string' && node.text.trim());
    if (node.type === 'image' || node.type === 'emailImage') return Boolean(node.attrs?.src?.trim());
    if (Array.isArray(node.content) && node.content.some((child) => hasContent(child, depth + 1))) return true;
    return Boolean(node.type && !containers.has(node.type));
  };
  return !hasContent(document);
}
